import { lazy as lazyLoad } from 'react';

import type { RouteDefinition } from '../../route';
import { route } from './constants';

const lazy = {
    CreateNewLearningOpportunityPage: lazyLoad(async () => {
        const { CreateLearningOpportunityForm } = await import('./create/CreateLearningOpportunityForm');

        return { default: CreateLearningOpportunityForm };
    }),
    EditLearningOpportunityPage: lazyLoad(async () => {
        const { EditLearningOpportunityForm } = await import('./edit/EditLearningOpportunityForm');

        return { default: EditLearningOpportunityForm };
    }),
    LearningOpportunitiesPage: lazyLoad(async () => {
        const { LearningOpportunitiesListPage } = await import('./list/LearningOpportunitiesListPage');

        return { default: LearningOpportunitiesListPage };
    }),
    LearningOpportunityDetailsPage: lazyLoad(async () => {
        const { LearningOpportunityDetailsPage } = await import('./details/LearningOpportunityDetailsPage');

        return { default: LearningOpportunityDetailsPage };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.learning-opportunities.headline',
        page: lazy.LearningOpportunitiesPage,
        path: route.patterns.learningOpportunities,
    },
    {
        documentTitle: 'pages.learning-opportunities.headline',
        page: lazy.EditLearningOpportunityPage,
        path: route.patterns.learningOpportunityEdit,
    },
    {
        documentTitle: 'pages.learning-opportunities.headline',
        page: lazy.CreateNewLearningOpportunityPage,
        path: route.patterns.createNewLearningOpportunity,
    },
    {
        documentTitle: 'pages.learning-opportunities.headline',
        page: lazy.LearningOpportunityDetailsPage,
        path: route.patterns.learningOpportunityDetails,
    },
];
